// import { Routes, Route, Navigate } from "react-router-dom";

// import Login from "./components/General/Login";
// import Pnf from "./components/General/Pnf";
// import Dashboard from "./components/Admin/Dashboard";
// import Manageprofile from "./components/Admin/Manageprofile";
// import Sidebar from "./components/General/Sidebar";
// import Viewusers from "./components/Admin/Viewusers";
// import Paymenthistory from "./components/Admin/Paymenthistory";
// import Transaction from "./components/Admin/Transaction";
// import Userwallet from "./components/Admin/Userwallet";

// function App() {
//   const data = localStorage.getItem("user");
//   const admin = data ? JSON.parse(data) : null;

//   return (
//     <Routes>
//       <Routes path="/home">Home</Routes>
//        <Routes path="/about">About-us</Routes>
//         <Routes path="/contact">Contact-us</Routes>
//          <Routes path="/privacy-policy">Privacy-policy</Routes>

//       <Route
//         path="/"
//         element={!admin ? <Login /> : <Navigate to="/admin/dashboard" />}
//       />

     
//       <Route path="/admin" element={<Sidebar admin={admin} />}>
//         <Route path="dashboard" element={<Dashboard />} />
//         <Route path="manageprofile" element={<Manageprofile />} />
//             <Route path="viewusers" element={<Viewusers />} />
//              <Route path="payment_history" element={<Paymenthistory />} />
//               <Route path="transaction" element={<Transaction />} />
//                 <Route path="user_wallet" element={<Userwallet />} />
//       </Route>

//       <Route path="*" element={<Pnf />} />

//     </Routes>
//   );
// }

// export default App;

import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/General/Login";
import Pnf from "./components/General/Pnf";
import Dashboard from "./components/Admin/Dashboard";
import Manageprofile from "./components/Admin/Manageprofile";
import Sidebar from "./components/General/Sidebar";
import Viewusers from "./components/Admin/Viewusers";
import Paymenthistory from "./components/Admin/Paymenthistory";
import Transaction from "./components/Admin/Transaction";
import Userwallet from "./components/Admin/Userwallet";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Contact from "./components/pages/Contact";
import Privacypolicy from "./components/pages/Privacypolicy";
import Header from "./components/General/Header";
import Footer from "./components/pages/Footer";
import SiteInquiry from "./components/Admin/SiteInquiry";
import Withdrawal from "./components/Admin/Withdrawal";
import ConfirmModal from "./components/General/Confirmationmodal";

function App() {
  const data = localStorage.getItem("user");
  const admin = data ? JSON.parse(data) : null;

  return (
    <Routes>
       <Route path="/" element={<Home />} />
       <Route path="/header" element={<Header />} />
  <Route path="/about" element={<About/>} />
   <Route path="/contact" element={<Contact/>} />
   <Route path="/privacy-policy" element={<Privacypolicy/>} />
       <Route path="/footer" element={<Footer/>} />

      <Route
        path="/admin-login"
        element={!admin ? <Login /> : <Navigate to="/admin/dashboard" />}
      />

     
      <Route path="/admin" element={<Sidebar admin={admin} />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="manageprofile" element={<Manageprofile />} />
            <Route path="viewusers" element={<Viewusers />} />
             <Route path="payment_history" element={<Paymenthistory />} />
              <Route path="transaction" element={<Transaction />} />
                <Route path="user_wallet" element={<Userwallet />} />
                  <Route path="site_inquiry" element={<SiteInquiry/>} />
                   <Route path="withdraw" element={<Withdrawal/>} />
                     <Route path="confirmationmodal" element={<ConfirmModal/>} />
      </Route>

      <Route path="*" element={<Pnf />} />

    </Routes>
  );
}

export default App;

